<template>
  <div class="home">
    <div class="container my-3 py-3 px-4">
      <div class="row mb-4 text-center"
          v-if="sites.length === 0"
      >
        <div class="col-12 text-uppercase">
          No sites available
        </div>
      </div>
      <div class="row">
        <div
          v-for="site in sites"
          :key="site.id"
          class="col-md-4 mb-3"
          style="height: 120px;"
        >
          <div
            class="card h-100 cursor-pointer"
            :style="`border-bottom: 8px solid #${site.color};`" 
            @click="goToSite(site.id, site.url)"
          >
            <div class="card-body">
              <h5 class="card-title">{{site.title}}</h5>
              <p class="card-text">{{site.description}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserSites, updateSiteToken } from '@/services/sites/site.api.js'

export default {
  name: 'Home',
  data() {
    return {
      sites: [],
    }
  },
  async mounted() {
    await this.getUserSites();
  },
  methods: {
    async getUserSites(){
      try {
        const {data} = await getUserSites();
        this.sites = data.sites.map(site => ({
          id: site.id,
          title: site.site,
          description: site.site_text,
          color: site.site_color.substring(4),
          url: site.web_url
        }));
      } catch (error) {
        this.$toast.open({
          message: error.message,
          type: 'error'
        })
      }
    },
    async goToSite(id, url) {
      try {
        const { data } = await updateSiteToken(id);
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = `${url}?authToken=${data.site_token}`;
        a.click();
      } catch (error) {
        this.$toast.open({
          message: 'Site currently not available',
          type: 'error'
        })
      }
    }
  },
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>